import { useEffect, useState } from "react";

interface ToastProps {
  message: string;
  onDone: () => void;
  durationMs?: number;
}

export function Toast({ message, onDone, durationMs = 2200 }: ToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const enter = requestAnimationFrame(() => setVisible(true));
    const fade = setTimeout(() => setVisible(false), durationMs - 300);
    const close = setTimeout(onDone, durationMs);
    return () => {
      cancelAnimationFrame(enter);
      clearTimeout(fade);
      clearTimeout(close);
    };
  }, [durationMs, onDone]);

  return (
    <div
      role="status"
      aria-live="polite"
      className={
        "pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4 transition-all duration-300 " +
        (visible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0")
      }
    >
      <div className="rounded-full border border-neutral-700/80 bg-neutral-900/95 px-5 py-2.5 text-[13px] font-medium text-neutral-100 shadow-xl backdrop-blur">
        {message}
      </div>
    </div>
  );
}
